/**
 * Small hover / focus bubble (t117u): detail that shouldn't take space in a row, e.g. who's in a team chip. Opens on
 * hover and on keyboard focus inside the trigger, so it isn't mouse-only; the content is also the trigger's accessible
 * description.
 */
import { useId, type ReactNode } from 'react';
import clsx from 'clsx';

export function HoverBubble({ bubble, children, className, align = 'start' }: { bubble: ReactNode; children: ReactNode; className?: string; align?: 'start' | 'end' }) {
  const id = useId();
  if (!bubble) return <>{children}</>;
  return (
    <span className={clsx('group/hb relative inline-flex', className)} aria-describedby={id}>
      {children}
      <span role="tooltip" id={id}
        className={clsx('pointer-events-none invisible absolute top-full z-50 mt-1 w-max max-w-[16rem] rounded-md bg-slate-900 px-2.5 py-1.5 text-xs font-normal leading-snug text-white opacity-0 shadow-lg transition-opacity delay-150 group-focus-within/hb:visible group-focus-within/hb:opacity-100 group-hover/hb:visible group-hover/hb:opacity-100 dark:bg-slate-700',
          align === 'end' ? 'right-0' : 'left-0')}>
        {bubble}
      </span>
    </span>
  );
}
